import React from 'react';
import { CustomDefaultTemplate } from '../../../templates/default';
import { Warning as GenericWarning } from '@fingermarkglobal/cringer.components';

const Warning = props => {
  return <GenericWarning {...props} Template={CustomDefaultTemplate} />;
};

export { Warning };
